import { isRedemptionRedeemed } from "@circle-react/helpers/paywallCouponHelpers";
import type { PaywallCouponRedemption } from "@circle-react/types/PaywallCouponRedemption";
import { CouponStatusBadge } from "@circle-react-shared/Paywalls/CouponStatusBadge";

export const CouponCodeColumn = (cellContext: any) => {
  const {
    row: { original: subscription },
  } = cellContext;

  const paywallCouponRedemption: PaywallCouponRedemption | undefined =
    subscription?.paywall_coupon_redemption;
  const paywallCouponCode = paywallCouponRedemption?.paywall_coupon?.code;
  const couponCodeString =
    paywallCouponRedemption &&
    isRedemptionRedeemed(paywallCouponRedemption.status)
      ? paywallCouponCode
      : "";

  return (
    <div className="whitespace-normal">
      {couponCodeString}
      {paywallCouponRedemption && (
        <CouponStatusBadge redemptionStatus={paywallCouponRedemption.status} />
      )}
    </div>
  );
};
